export default "__VITE_ASSET__DeQMpj0d__"